/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SmartForm } from 'components';
import { saveSetting, getSetting } from 'rdx/config';
import { valueToInteger } from 'utils';
import SmartField from 'components/SmartForm/SmartField';

import returnReceiptSchema from './returnReceiptSchema';

import './returnReceipt.scss';

function ReturnTenders() {
  const settingsFormRef = React.useRef(null);
  const dispatch = useDispatch();
  const [configState, setConfigState] = useState({});

  const pos_allow_return_receipt_cash = useSelector(
    getSetting('pos_allow_return_receipt_cash'),
  );
  const pos_allow_return_receipt_card = useSelector(
    getSetting('pos_allow_return_receipt_card'),
  );
  const pos_allow_return_receipt_giftcard_serial = useSelector(
    getSetting('pos_allow_return_receipt_giftcard_serial'),
  );
  const pos_allow_return_receipt_giftcard_regular = useSelector(
    getSetting('pos_allow_return_receipt_giftcard_regular'),
  );
  const pos_allow_return_receipt_storecredit = useSelector(
    getSetting('pos_allow_return_receipt_storecredit'),
  );
  const pos_allow_return_receipt_check = useSelector(
    getSetting('pos_allow_return_receipt_check'),
  );

  const pos_allow_return_receipt_cash_limit = useSelector(
    getSetting('pos_allow_return_receipt_cash_limit'),
  );
  const pos_allow_return_receipt_card_limit = useSelector(
    getSetting('pos_allow_return_receipt_card_limit'),
  );
  const pos_allow_return_receipt_giftcard_serial_limit = useSelector(
    getSetting('pos_allow_return_receipt_giftcard_serial_limit'),
  );
  const pos_allow_return_receipt_giftcard_regular_limit = useSelector(
    getSetting('pos_allow_return_receipt_giftcard_regular_limit'),
  );
  const pos_allow_return_receipt_storecredit_limit = useSelector(
    getSetting('pos_allow_return_receipt_storecredit_limit'),
  );
  const pos_allow_return_receipt_check_limit = useSelector(
    getSetting('pos_allow_return_receipt_check_limit'),
  );
  const pos_allow_return_receipt_original_tender_only = useSelector(
    getSetting('pos_allow_return_receipt_original_tender_only'),
  );

  useEffect(() => {
    setConfigState({
      pos_allow_return_receipt_cash,
      pos_allow_return_receipt_card,
      pos_allow_return_receipt_giftcard_serial,
      pos_allow_return_receipt_giftcard_regular,
      pos_allow_return_receipt_storecredit,
      pos_allow_return_receipt_check,
      pos_allow_return_receipt_cash_limit,
      pos_allow_return_receipt_card_limit,
      pos_allow_return_receipt_giftcard_serial_limit,
      pos_allow_return_receipt_giftcard_regular_limit,
      pos_allow_return_receipt_storecredit_limit,
      pos_allow_return_receipt_check_limit,
      pos_allow_return_receipt_original_tender_only,
    });
  }, [
    pos_allow_return_receipt_cash,
    pos_allow_return_receipt_card,
    pos_allow_return_receipt_giftcard_serial,
    pos_allow_return_receipt_giftcard_regular,
    pos_allow_return_receipt_storecredit,
    pos_allow_return_receipt_check,
    pos_allow_return_receipt_cash_limit,
    pos_allow_return_receipt_card_limit,
    pos_allow_return_receipt_giftcard_serial_limit,
    pos_allow_return_receipt_giftcard_regular_limit,
    pos_allow_return_receipt_storecredit_limit,
    pos_allow_return_receipt_check_limit,
    pos_allow_return_receipt_original_tender_only,
  ]);

  const submitSetting = () => {
    const { values: currentValues } = settingsFormRef.current;

    Object.entries(currentValues).forEach(([key, value]) => {
      const payload = {};

      payload.parameterName = key;
      payload.parameterValue =
        typeof value === 'boolean' ? valueToInteger(value) : value;
      if (payload.parameterValue !== configState[key])
        dispatch(saveSetting(payload));
    });
  };
  const setInputDisabled = (name, value) => {
    const index = returnReceiptSchema.findIndex((field) => field.name === name);
    returnReceiptSchema[index].input.disabled = value;
  };
  return (
    <SmartForm
      grid
      autosave
      ref={settingsFormRef}
      state={configState}
      fields={returnReceiptSchema}
      handleSubmit={submitSetting}
      className="tender-form"
      renderInput={({ field, props, autosave }) => {
        if (
          [
            'pos_allow_return_receipt_cash',
            'pos_allow_return_receipt_card',
            'pos_allow_return_receipt_giftcard_serial',
            'pos_allow_return_receipt_giftcard_regular',
            'pos_allow_return_receipt_storecredit',
            'pos_allow_return_receipt_check',
          ].includes(field.name)
        ) {
          if (props.values[field.name])
            setInputDisabled(`${field.name}_limit`, false);
          else {
            setInputDisabled(`${field.name}_limit`, true);
            // eslint-disable-next-line no-param-reassign
            props.values[`${field.name}_limit`] = '';
          }
        }

        if (field.name.includes('_limit')) {
          return (
            <SmartField
              key={field.name}
              autosave={autosave}
              name={field.name}
              input={{ ...field.input }}
              {...props}
            />
          );
        }
        return null;
      }}
    />
  );
}

export default ReturnTenders;
